<template>
  <div class="quick-query">
    <Poptip content="content" placement="bottom-start">
      <template #content>
        <div class="q-content">
          <tabooInfo v-uEdition="'YZ-24'" :info="info" />
          <medicalConsultationInformation v-uEdition="'YZ-26'" :info="info" />
        </div>
      </template>
      <!-- <Button class="quick-query-btn" :size="btnSize" icon="md-search" -->
      <Button class="quick-query-btn" :size="btnSize"
        ><Icon type="md-search" />快捷查询</Button
      >
    </Poptip>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    btnSize: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.quick-query {
  display: inline-block;
  .quick-query-btn {
    border-color: #853a2f;
    color: #853a2f;
    font-size: 13px;
  }
  .q-content {
    padding: 10px;
    & > * {
      margin: 2px 5px;
    }
  }
  .ivu-icon {
    background: #853a2f;
    padding: 1px 1px 0;
    border-radius: 3px;
    color: #fff;
    margin-right: 3px;
  }
}
</style>